"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");require("core-js/modules/es6.array.find");require("core-js/modules/es6.function.name");var _objectSpread2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/objectSpread2"));


























































































var _vuex = require("vuex");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({ username: 'getUsername' })), components: {}, data: function data() {return { tableData: [], // 列表数据
      searchData: { page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', addData: { id: '', programId: '', languageId: '', languageCode: '', name: '', remarks: '', notice: '' }, defaultData: { id: '', programId: '', languageId: '', name: '', remarks: '', notice: '' }, languageList: [], tableColumns: [{ prop: 'programId', label: '指令id', isShow: true }, { prop: 'programName', label: '指令名称', isShow: true }, { prop: 'name', label: '翻译-名称', isShow: true }, { prop: 'remarks', label: '翻译-说明', isShow: true }, { prop: 'languageCode', label: '语言类型', isShow: true }, { prop: 'languageName', label: '语言标识', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'operatorName', label: '操作人', isShow: true }], rules: { programId: [{ required: true, message: '请输入指令Id',
          trigger: 'blur' }],

        languageId: [{
          required: true,
          message: '请选择语言类型',
          trigger: 'blur' }],

        name: [{
          required: true,
          message: '请输入翻译-名称',
          trigger: 'blur' }],

        remarks: [{
          required: true,
          message: '请输入翻译-说明',
          trigger: 'blur' }] },


      delIds: '' };

  },

  mounted: function mounted() {
    var self = this;
    self.searchData.programId = self.$route.params.parentId;
    self.defaultData.programId = self.$route.params.parentId;
    self.addData.programId = self.$route.params.parentId;
    self.init();
    self.getLanguageList();
  },
  methods: {
    init: function init() {
      var self = this;
      self.getData('/api/programLanguage/' + self.$route.params.parentId, self.searchData, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    getLanguageList: function getLanguageList() {
      var self = this;
      self.getData('/api/language/list', {}, function (res) {
        self.languageList = res;
      });
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    delMenu: function delMenu(item) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/programLanguage/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    onSubmit: function onSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var data = {
            programId: self.$route.params.parentId,
            languageId: self.addData.languageId,
            name: self.addData.name,
            remarks: self.addData.remarks };

          self.putData('/api/programLanguage', data, function (res) {
            self.$message({
              message: '新增成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {
      this.title = '编辑';
      var self = this;
      var obj = self.languageList.find(function (lan) {
        if (lan.type === item.languageCode) {
          return lan;
        }
      });
      this.addData = {
        id: item.id,
        programId: item.programId,
        languageId: obj.id,
        name: item.name,
        remarks: item.remarks };

      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {var _this = this;
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var data = _this.addData;
          self.putData('/api/programLanguage', data, function (res) {
            self.$message({
              message: '新增成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {var _this2 = this;
      this.delIds = '';
      val.map(function (item) {
        _this2.delIds += item.id + ',';
      });
    },
    delListFun: function delListFun() {
      var self = this;
      var ids = self.delIds.substr(0, self.delIds.length - 1).split(',');
      var idList = ids.map(function (el) {
        return parseInt(el);
      });
      if (self.delIds === '') {
        self.$message({
          message: '请选择要删除的记录!',
          type: 'warning' });

        return;
      }
      self.$confirm('确定删除这些记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.postData('/api/faInstorageDetail/batchDelete', idList, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/instructions/instructionslist');
    }
    // changeLanguage: function(value) { // 下拉
    //   let obj = {}
    //   obj = this.languageList.find((item) => {
    //     return item.id === value
    //   })
    //   this.addData.type = obj.type
    // }
  } };exports.default = _default;